import { payrollLocationTableColumnsOptions } from '@/constants/tables/payrollLocation/payrollLocationTableColumns';

export const getInitPayrollLocationColumns = () => {
  const initialColumns = ['employee', 'absences', 'workTime', 'nightWorkTime', 'payout', 'warnings'];
  return payrollLocationTableColumnsOptions.filter(option => initialColumns.includes(option.accessor));
};
